(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('selectPoFinish', {
        templateUrl: 'views/components/views/selectPoFinish/selectPoFinish.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'utilityService', 'selectPoFinishService', 'paperLessPoService', 'trNewJobService', function ($stateParams, utilityService, selectPoFinishService, paperLessPoService, trNewJobService) {

            // #region VARIABLES & DEFINITIONS
            
            const vm = this;
            let webPageName = $stateParams.webpagename;

            vm.model = {
                bgOpenOptions: {
                    selected: 'selectpofinish_open',
                    buttons: [
                        { id: 'selectpofinish_open', label: 'selectpofinish_open', color: 'primary', onClick: () => vm.model.bgOpenOptions.selected = 'selectpofinish_open' },
                        { id: 'selectpofinish_notopen', label: 'selectpofinish_notopen', color: 'primary', onClick: () => vm.model.bgOpenOptions.selected = 'selectpofinish_notopen' }
                    ]
                },
                bgFinishOptions: {
                    selected: 'selectpofinish_open_mine',
                    buttons: [
                        { id: 'selectpofinish_open_mine', label: 'selectpofinish_open_mine', color: 'primary', onClick: () => vm.model.bgFinishOptions.selected = 'selectpofinish_open_mine' },
                        { id: 'selectpofinish_open_other', label: 'selectpofinish_open_other', color: 'primary', onClick: () => vm.model.bgFinishOptions.selected = 'selectpofinish_open_other' }
                    ]
                },
                filterValueButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filtervalue = '' }
                ],
                setting: {
                    filtervalue: ''
                },
                itemsListFinishedProductionOrders: [],
                itemsListProductionOrders: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE CALLS
            
            async function loadSetting() {
                vm.model.setting = (await paperLessPoService.getPaperLessPo({ webpagename: webPageName }))[0];

                if (vm.model.bgOpenOptions.selected === 'selectpofinish_open') loadFinishedProductionOrders(vm.model.bgFinishOptions.selected);
            }
            
            async function loadFinishedProductionOrders(selectType) {
                vm.model.itemsListFinishedProductionOrders = await selectPoFinishService.listFinishedProductionOrders({ select_type: selectType });
            }

            async function loadProductionOrders() {
                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.operation_id) !== true) return;

                return vm.model.itemsListProductionOrders = await selectPoFinishService.listProductionOrders({
                    stockplace_id: vm.model.setting.stockplace_id,
                    operation_id: vm.model.setting.operation_id
                });
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region BUTTON RADIO FUNCTIONS

            vm.selectBgOpenOptions = function (value) {
                vm.model.bgOpenOptions.selected = value;

                if (vm.model.bgOpenOptions.selected === 'selectpofinish_notopen') {
                    loadProductionOrders();
                } else {
                    loadFinishedProductionOrders(vm.model.bgFinishOptions.selected);
                }
            };
            
            vm.selectBgFinishOptions = function (value) {
                vm.model.bgFinishOptions.selected = value;

                loadFinishedProductionOrders(vm.model.bgFinishOptions.selected);
            };
            
            // #endregion BUTTON RADIO FUNCTIONS

            // #region SAVE ITEM MULTI FUNCTIONS
            
            vm.goBackToPrevious = function (id, item) {
                switch (id) {
                    case 'itemsListFinishedProductionOrders':
                        selectPoFinishService.saveItem({
                            p2_pofinish_keyno: item.item_id,
                            webpagename: webPageName
                        });
                        break;
                    case 'itemsListProductionOrders':
                        trNewJobService.scanProductionOrder({ barcode: item.barcode }).then((response) => {
                            if (response[0].p2_pofinish_keyno > 0) {
                                selectPoFinishService.saveItem({
                                    p2_pofinish_keyno: response[0].p2_pofinish_keyno,
                                    webpagename: webPageName
                                });
                            }
                        });
                        break;
                    default:
                        break;
                }
            };

            // #endregion SAVE ITEM MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadSetting();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
